import { render, staticRenderFns } from "./private-fl44-unknown-volume-contract-supplier-block.vue?vue&type=template&id=3324f5ed&"
import script from "./private-fl44-unknown-volume-contract-supplier-block.vue?vue&type=script&lang=js&"
export * from "./private-fl44-unknown-volume-contract-supplier-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3324f5ed')) {
      api.createRecord('3324f5ed', component.options)
    } else {
      api.reload('3324f5ed', component.options)
    }
    module.hot.accept("./private-fl44-unknown-volume-contract-supplier-block.vue?vue&type=template&id=3324f5ed&", function () {
      api.rerender('3324f5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-contract-supplier-block.vue"
export default component.exports